// Mobile-only, collection page only.
//
// 1. Hides the sticky Filter/Sort bar (Horizon's native .facets-toggle) once
//    the product grid has scrolled out of view - it stays visible by default
//    (see the CSS) so a slow/blocked script never hides real functionality,
//    it only ever hides the bar once it's confirmed safe to.
// 2. Adds a "Sort" button next to the existing "Filter" button. Horizon
//    already bundles both filtering and sorting into the same #filters-drawer
//    when both are enabled, so Sort opens that same drawer - it just gives
//    sorting its own visible entry point alongside Filter instead of being
//    reachable only from inside the filter drawer.
const SORT_ICON = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" aria-hidden="true">
  <path d="M6 4v12M6 16l-3-3M6 16l3-3M14 16V4M14 4l-3 3M14 4l3 3" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
</svg>`;

function addMobileSortButton() {
  const wrapper = document.querySelector('.facets-toggle__wrapper');
  const drawer = document.getElementById('filters-drawer');

  if (!wrapper || !drawer || wrapper.parentElement.querySelector('.collection-grid-mobile-sort')) return;

  const sortButton = document.createElement('button');
  sortButton.type = 'button';
  sortButton.className = 'collection-grid-mobile-sort';
  sortButton.setAttribute('aria-haspopup', 'dialog');
  sortButton.innerHTML = `${SORT_ICON}<span>Sort</span>`;
  sortButton.addEventListener('click', () => {
    if (typeof drawer.open === 'function') drawer.open();
  });

  wrapper.insertAdjacentElement('afterend', sortButton);
}

function initCollectionGridMobileVisibility() {
  const toggle = document.querySelector('.facets-toggle');
  const grid = document.querySelector('.main-collection-grid');

  if (!toggle || !grid) return;

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        toggle.classList.toggle('is-hidden', !entry.isIntersecting);
      });
    },
    { threshold: 0 }
  );

  observer.observe(grid);
}

function init() {
  addMobileSortButton();
  initCollectionGridMobileVisibility();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
